import React from 'react';
import { Fragment } from 'react';
import { Row, Col, Container, Alert, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Header from '../../components/header';
import Footer from '../../components/footer';
import Head from '../../components/head';
import Item from '../../components/itens/item'


function ContasScreen() {
    return (
        <Fragment>
            <Head titulo="Contas da Prefeitura de Macuco" />
            <Header />
            <Container>
                <Row xs={1}>
                    <Col xs={{ span: 2, offset: 11 }}>
                        <Link to='/'>
                            <Button type='button' variant='danger'>Voltar</Button>
                        </Link>
                    </Col>
                </Row>                
                <Row xs={1} lg={3}>
                    <Col>
                        <Item
                            titulo={"Prestação de Contas"}
                            descricao={"Prestação de contas da Prefeitura de Macuco sobre o exercício dos anos anteriores, aprovadas pelo Tribunal de Contas do Estado do Rio de Janeiro."}
                            link={"contas/prestacaocontas"}
                            key={1}
                        />
                    </Col>
                    <Col>
                        <Item
                            titulo={"Audiência Pública"}
                            descricao={"Atas das Audiências Públicas de apresentação de Metas Fiscais e Orçamento da Saúde"}
                            link={"contas/audiencias"}
                            key={2}
                        />
                    </Col>
                    <Col>
                        <Item
                            titulo={"Decretos do Legislativo"}
                            descricao={"Resultados das Apreciações feitas pelo Poder Legislativo das Prestações de Contas do Município"}
                            link={"contas/camara"}
                            key={3}
                        />
                    </Col>
                </Row>
            </Container>
            <Footer />
        </Fragment>
    );
}

export default ContasScreen;